import ExcelJS from "exceljs";
import { calibrationService, DEFAULT_GROUP_KEY } from "../../../../services/CalibrationService";

const SENSOR_FIELD_PLAN_DATASET_TYPE = "sensor-field-plan";

const PICK_LIST_FIELDS = {
    sensors: [
        { key: "rs1_50w_standard_sim",      description: "RS1 Camera device with 50W Power Module device, Standard with Soracom SIM", part_number: null },
        { key: "rs1_50w_bespoke_sim",        description: "RS1 Camera device with 50W Power Module device, Bespoke SIM", part_number: null },
        { key: "rs1_100w_standard_sim",      description: "RS1 Camera device with 100W Power Module device, Standard with Soracom SIM", part_number: null },
        { key: "rs1_100w_bespoke_sim",       description: "RS1 Camera device with 100W Power Module device, Bespoke SIM", part_number: null },
        { key: "weather_station_assembly",   description: "Weather Station Assembly", part_number: "LNV-200-100007" },
    ],
    hardware: [
        { key: "lattice_small_mounting_kit", title: "RS1 Mounting Kit, Lattice Small", description: "Contains Three SLM-L bracets with 10 rods, Weather Sensor Mounting Arm Assembly, Camera Mounting Assembly, Power Module Mounting Assembly", part_number: "LNV-200-100012" },
        { key: "lattice_large_mounting_kit", title: "RS1 Mounting Kit, Lattice Large", description: "Contains Three SLM-L brackets with 18 rods, Weather Sensor Mounting Arm Assembly, Camera Mounting Assembly, Power Module Mounting Assembly", part_number: "LNV-200-100011" },
        { key: "monopole_mounting_kit",      title: "RS1 Mounting Kit, Monopole", description: "Contains Three SLM-H brackets, Weather Sensor Mounting Arm Assembly, Camera Mounting Assembly, Power Module Mounting Assembly", part_number: "LNV-200-100010" },
        { key: "banding_roll_201_ss",        title: "Banding Rolls 201SS", description: "One roll of banding", part_number: "LNV-210-100022" },
        { key: "banding_roll_316_ss",        title: "Banding Rolls 316SS", description: "One roll of banding", part_number: "LNV-210-100023" },
        { key: "num_banding_cutters",        title: "Banding Cutters", description: "One Cutter tool", part_number: "LNV-210-100024" },
    ],
};

function applyBold(cell) {
    cell.font = { bold: true, size: 12 };
}

function addItemRow(ws, field, quantity) {
    const row = ws.addRow([field.part_number, null, quantity, null]);
    if (field.title) {
        row.getCell(2).value = {
            richText: [
                { text: field.title + "\n", font: { bold: true, size: 11 } },
                { text: field.description, font: { size: 11 } },
            ],
        };
    } else {
        row.getCell(2).value = field.description;
    }
}

function addSection(ws, fields, quantities) {
    const greyRow = ws.addRow([]);
    for (let col = 1; col <= 5; col++) {
        greyRow.getCell(col).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD3D3D3" } };
    }
    const headerRow = ws.addRow(["Form IQ Part Number", "Item Description", "Quantity", "Comments"]);
    headerRow.font = { bold: true, size: 12 };
    fields.forEach((field) => addItemRow(ws, field, quantities[field.key]));
}

export async function generatePickList(clientName, projectName) {
    const result = await calibrationService.getLatestDatasetViaSignedUrl(
        clientName, projectName, DEFAULT_GROUP_KEY, SENSOR_FIELD_PLAN_DATASET_TYPE
    );
    if (!result?.data) return;
    const versionDttm = result.meta?.version_dttm;
    const quantities = result.data.pick_list_quantities;

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Pick List");

    ws.getColumn(1).width = 22;
    ws.getColumn(2).width = 40;
    ws.getColumn(2).alignment = { wrapText: true };
    ws.getColumn(3).width = 15;
    ws.getColumn(4).width = 25;
    ws.getColumn(5).width = 15;
    ws.getColumn(6).width = 30;
    ws.getColumn(7).width = 25;

    const row1 = ws.addRow(["Client Name:", clientName, null, "Delivery Address:", null, null, null]);
    const row2 = ws.addRow(["Project Title:", projectName, null, "Delivery Contact:", null, null, null]);
    const row3 = ws.addRow(["Delivered By Date:", null, null, "Delivery Hours", null, null, null]);
    const row4 = ws.addRow(["Projected Ship By Date", null, null, "Liftgate Required", null, null, null]);

    [row1, row2, row3, row4].forEach((row) => {
        row.font = { size: 12 };
        applyBold(row.getCell(1));
        applyBold(row.getCell(4));
        ws.mergeCells(row.number, 2, row.number, 3);
        ws.mergeCells(row.number, 6, row.number, 7);
    });

    ws.addRow([]);

    addSection(ws, PICK_LIST_FIELDS.sensors, quantities);
    addSection(ws, PICK_LIST_FIELDS.hardware, quantities);

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const dttmStamp = versionDttm ? `_${versionDttm.replace(/\.\d+/, "").replace(/[:.]/g, "-").replace("Z", "")}` : "";
    a.download = `${clientName}_${projectName}_pick-list${dttmStamp}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
